import { Auth } from "../../ts/Auth";
import { UserRole } from "../../types/role";

const initialState: Auth = {
  user: {
    _id: "",
    firstName: "",
    lastName: "",
    function: UserRole.Klient,
    mobil: "",
    eshop_id: "",
    email: "",
    last_online: null,
  },
  logged: false,
  isLoading: true,
};

type Action = {
  type: string;
  payload: any;
};

export const authReducer = (state: Auth = initialState, action: Action) => {
  switch (action.type) {
    case "SET_USER":
      if (action.payload) {
        return {
          ...state,
          user: action.payload,
          logged: true,
          isLoading: false,
        };
      }

      return {
        ...state,
        user: initialState.user,
        logged: false,
        isLoading: false,
      };
    default:
      return state;
  }
};
